export default function sortBy(property) {
    return (a, b) => a[property] > b[property] ? 1 : -1;
};